import React from 'react';
import PropTypes from 'prop-types';
import Info from '@mui/icons-material/Info';

import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

import InfoBox from '../../exceed/components/infoBox';

import styles from '../styles/formDecorationInfo.module.scss';

const FormDecorationInfo = ({ schema }) => (
  <InfoBox className={styles.infoBox}>
    <Info className={styles.icon} sx={{ height: 18, width: 18 }} />
    <Typo element="span" variant="b01">{schema.text}</Typo>
  </InfoBox>
);

FormDecorationInfo.propTypes = {
  schema: PropTypes.shape({ text: PropTypes.string.isRequired }).isRequired,
};

registerDecoration('Info', React.memo(FormDecorationInfo));

export default FormDecorationInfo;
